import { useCallback, useEffect } from 'react'
import TagManager from 'react-gtm-module'

import type { Recommendation, RecommendationId } from '../../modules/Recommendations'
import { useUserLifecycleQueryWithShop } from '../../modules/Recommendations/queries/useUserLifecycleQuery'

const LAUNCH_NEW_PRODUCTS_RECOMMENDATIONS: RecommendationId[] = [
  'campaign',
  'homeProducts',
  'createProduct',
  'orderSamples',
  'joinDiscord',
  'inviteTeam',
  'creatorApp',
  'customDomain',
  'digitalProduct',
  'memberships',
]

const EARN_MORE_RECOMMENDATIONS: RecommendationId[] = [
  'campaign',
  'payouts',
  'referral',
  'integrations',
  'twitchPromotion',
  'twitchGifting',
  'freeShipping',
  'cartAbandonmentEmailPromo',
  'customDomain',
  'addReferralLinkToHomepage',
  'googleAnalytics',
  'homeProducts',
  'createProduct',
  'orderSamples',
  'creatorApp',
  'inviteTeam',
]

export const usePersonalizedRecommendations = (
  recommendations: Recommendation[] | undefined,
): {
  personalizedRecommendations: Recommendation[]
} => {
  const { lifecycle } = useUserLifecycleQueryWithShop()

  useEffect(() => {
    if (lifecycle) {
      TagManager.dataLayer({ dataLayer: { userLifecycle: lifecycle } })
    }
  }, [lifecycle])

  const filterList = useCallback(
    (list: Recommendation[] | undefined) => {
      if (!list) return []
      if (!lifecycle) return list

      const allowedRecommendations =
        lifecycle === 'LAUNCH_MORE_PRODUCTS' || lifecycle === undefined
          ? LAUNCH_NEW_PRODUCTS_RECOMMENDATIONS
          : EARN_MORE_RECOMMENDATIONS

      return list.filter((rec) => allowedRecommendations.includes(rec.id))
    },
    [lifecycle],
  )

  return {
    personalizedRecommendations: filterList(recommendations),
  }
}
